// extracted by mini-css-extract-plugin
export var deleteModal = "_jz-0";